import { createSelector } from 'reselect';
import {
  isWeekly,
  isSubsidizedProduct,
  getDiscountSubsidized,
  MIN_DISCOUNT,
} from '@shopDetails/utils/discounts';
import getShop from '@core/reducers/shop/selectors/getShop';
import getMenuWithDiscounts from '@core/reducers/menu/selectors/getMenuWithDiscounts';
import { NOT_SET } from '@utils/tracking/constants';

const MAX_ITEMS = 15;

const isExceedLimit = (weeklys, subsidized) =>
  weeklys.length + subsidized.length >= MAX_ITEMS;

const getStringProductsTagged = (sections, discountFromShop) => {
  const weeklys = [];
  const subsidized = [];
  sections.forEach(section => {
    const { products } = section;
    if (products.length) {
      products.forEach(product => {
        if (!isExceedLimit(weeklys, subsidized)) {
          if (isWeekly(product) && discountFromShop >= MIN_DISCOUNT) {
            weeklys.push(product.id);
          }
          if (
            isSubsidizedProduct(product) &&
            getDiscountSubsidized(
              product.price,
              product.subsidizedProduct.originalPrice,
            ) >= MIN_DISCOUNT
          ) {
            subsidized.push(product.id);
          }
        }
      });
    }
  });

  const idsWeeklys = weeklys.toString() || NOT_SET;
  const idsSubsidized = subsidized.toString() || NOT_SET;

  return `weekly - ${idsWeeklys} | subsidized - ${idsSubsidized}`;
};

export default createSelector(getMenuWithDiscounts, getShop, (menu, shop) => {
  if (menu) {
    const { sections } = menu;
    if (sections.length) {
      return getStringProductsTagged(sections, shop?.discount);
    }
  }
  return NOT_SET;
});
